export const getSitesApi = async ( apiInstance: API.Client ) => {
  const sites = await apiInstance.Entity.collection( 'site') .getAll();

  return sites as DataModel.Site[];
};
